import ko from "lib/knockout";
import {ReviewItem} from "./model/reviewitem";
import {ReviewComment} from "./model/reviewcomment";
import {ReviewList} from "./model/reviewlist";
import {ReviewItemMobile} from "./model/reviewitemmobile";
import {ReviewListMobile} from "./model/reviewlistmobile";

ko.components.register('review-list', {
	viewModel: {
		createViewModel: function (params) {
			return params instanceof ReviewList ? params : new ReviewList(params);
		}
	},
	template: require('./templates/review-list.html')
});

ko.components.register('review-item', {
	viewModel: {
		createViewModel: function (params) {
			return params instanceof ReviewItem ? params : new ReviewItem(params);
		}
	},
	template: require('./templates/review-item.html')
});

ko.components.register('review-comment', {
	viewModel: {
		createViewModel: function (params) {
			return params instanceof ReviewComment ? params : new ReviewComment(params);
		}
	},
	template: require('./templates/review-comment.html')
});

ko.components.register('review-list-mobile', {
    viewModel: {
        createViewModel: function (params) {
            return params instanceof ReviewListMobile ? params : new ReviewListMobile(params);
        }
    },
    template: require('./templates/review-list-mobile.html')
});

ko.components.register('review-item-mobile', {
    viewModel: {
        createViewModel: function (params) {
            return params instanceof ReviewItemMobile ? params : new ReviewItemMobile(params);
        }
    },
    template: require('./templates/review-item-mobile.html')
});



// WEBPACK FOOTER //
// ./modules/reviews/common/components.js